<script>
  import { onDestroy } from 'svelte';
  import { connectionStore, mqttErrorStore, reconnectNow } from '../stores.js';
  import { TEXT } from '../ui-text.js';

  // Короткие переподключения (штатный флап WSS на iOS) не должны мигать баннером:
  // состояние 'connecting' показываем, только если оно держится дольше 2 секунд.
  const CONNECTING_SHOW_DELAY_MS = 2000;
  let connectingVisible = false;
  let connectingTimer = null;

  $: {
    if ($connectionStore === 'connecting') {
      if (!connectingTimer && !connectingVisible) {
        connectingTimer = setTimeout(() => {
          connectingTimer = null;
          connectingVisible = true;
        }, CONNECTING_SHOW_DELAY_MS);
      }
    } else {
      if (connectingTimer) {
        clearTimeout(connectingTimer);
        connectingTimer = null;
      }
      connectingVisible = false;
    }
  }

  onDestroy(() => {
    if (connectingTimer) {
      clearTimeout(connectingTimer);
      connectingTimer = null;
    }
  });

  $: isOffline = $connectionStore !== 'connected'
    && ($connectionStore !== 'connecting' || connectingVisible);
  $: fallbackStatusText = {
    'connecting': TEXT.connection.connecting,
    'disconnected': TEXT.connection.disconnected,
    'error': TEXT.connection.error,
    'offline': TEXT.connection.browserOffline,
  }[$connectionStore] || '';
  $: statusText = $mqttErrorStore || fallbackStatusText;
</script>

<!-- В8 (1.27.2): плашка стоит в потоке над экраном, а не поверх шапки: раньше она
     закрывала «←», поиск и «⋮» на всё время переподключения (до двух минут).
     Тап — немедленная попытка переподключиться. -->
{#if isOffline}
  <button
    type="button"
    class="connection-banner"
    aria-live="polite"
    aria-label={`${statusText} ${TEXT.connection.retryNowAria}`}
    class:error={$connectionStore === 'error'}
    on:click={reconnectNow}
  >
    <span class="icon" aria-hidden="true">⚡</span>
    <span>{statusText}</span>
    <span class="retry" aria-hidden="true">{TEXT.connection.retryNow}</span>
  </button>
{/if}

<style>
  .connection-banner {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    width: 100%;
    min-height: 40px;
    padding: 0.4rem 0.75rem;
    border: none;
    background: var(--warning-bg);
    color: var(--warning-text);
    font: inherit;
    font-size: 0.875rem;
    text-align: center;
    cursor: pointer;
  }

  .retry {
    font-weight: 600;
    text-decoration: underline;
  }

  .connection-banner.error {
    background: var(--error-bg);
    color: var(--error-text);
  }

  .icon {
    font-size: 1rem;
  }
</style>
